import React from "react";
import { Link } from "react-router-dom";

// NOTE: Internal page links use <Link> from react-router-dom instead of
// plain <a> tags, so navigation happens without a full page reload.
// External / hash links (like "#" for dropdown toggles) stay as <a>.

function Header() {
  return (
    <header id="header" className="tra-menu navbar-light">
      <div className="header-wrapper">
        {/* MOBILE HEADER */}
        <div className="wsmobileheader clearfix">
          <span className="smllogo">
            <Link to="/">
              <img className="lt-img" src="/legacy/images/img/logo.png" alt="mobile-logo" />
              <img className="dt-img" src="/legacy/images/img/logo.png" alt="mobile-logo" />
            </Link>
          </span>
          <a id="wsnavtoggle" className="wsanimated-arrow">
            <span></span>
          </a>
        </div>

        {/* NAVIGATION MENU */}
        <div className="wsmainfull menu clearfix">
          <div className="wsmainwp clearfix">
            {/* HEADER BLACK LOGO */}
            <div className="desktoplogo">
              <Link to="/" className="logo-black">
                <img className="lt-img" src="/legacy/images/img/logo-w-l.svg" alt="logo" />
                <img className="dt-img" src="/legacy/images/img/logo-w-l.svg" alt="logo" />
              </Link>
            </div>

            {/* HEADER WHITE LOGO */}
            <div className="desktoplogo">
              <Link to="/" className="logo-white">
                <img src="/legacy/images/img/logo-w-l-w.svg" alt="logo" />
              </Link>
            </div>

            {/* MAIN MENU */}
            <nav className="wsmenu clearfix">
              <ul className="wsmenu-list nav-plum">

                <li aria-haspopup="true" className="mg_link">
                  <a href="#" className="h-link">
                    Website <span className="wsarrow"></span>
                  </a>
                  <div className="wsmegamenu w-75 clearfix">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-3">
                          <ul className="link-list">
                            <li><Link to="/web-development">Web Development</Link></li>
                            <li><Link to="/dynamic-website-designing">Dynamic Website Designing</Link></li>
                            <li><Link to="/static-website-designing">Static Website Designing</Link></li>
                          </ul>
                        </div>
                        <div className="col-lg-3">
                          <ul className="link-list">
                            <li><Link to="/mobile-website-design">Mobile Website Design</Link></li>
                            <li><Link to="/mobile-apps-development">Mobile Apps Development</Link></li>
                            <li><Link to="/responsive-website-designing">Responsive Website Designing</Link></li>
                          </ul>
                        </div>
                        <div className="col-lg-3">
                          <ul className="link-list">
                            <li><Link to="/e-commerce-website">E- Commerce Website</Link></li>
                            <li><Link to="/web-portals">Web Portals</Link></li>
                            <li><Link to="/website-maintenance">Website Maintenance</Link></li>
                          </ul>
                        </div>
                        <div className="col-lg-3">
                          <ul className="link-list">
                            <li><Link to="/flash-websites">Flash Website</Link></li>
                            <li><Link to="/web-portals">Web Portals</Link></li>
                            <li><a href="#">Website Packages</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li aria-haspopup="true">
                  <span className="wsmenu-click"><i className="wsmenu-arrow"></i></span>
                  <a href="#" className="h-link">
                    Domains &amp; Hosting <span className="wsarrow"></span>
                  </a>
                  <ul className="sub-menu ico-10">
                    <li><Link to="/registering-domain">Registering Domain</Link></li>
                    <li><Link to="/renewal-of-domain">Renewal of Domain</Link></li>
                    <li><Link to="/ae-domain-registration">AE Domain Registration</Link></li>
                    <li><Link to="/transferring-of-domain">Transferring of Domain</Link></li>
                    <li><Link to="/.com-domain-registration">.Com Domain Registration</Link></li>
                    <li><Link to="/dedicated-hosting">Dedicated Hosting</Link></li>
                    <li><Link to="/website-hosting">Website Hosting</Link></li>
                    <li><Link to="/sharing-hosting">Sharing Hosting</Link></li>
                  </ul>
                </li>

                <li aria-haspopup="true">
                  <span className="wsmenu-click"><i className="wsmenu-arrow"></i></span>
                  <a href="#" className="h-link">
                    Online Marketing <span className="wsarrow"></span>
                  </a>
                  <ul className="sub-menu ico-10">
                    <li><Link to="/brand-management">Brand Management</Link></li>
                    <li><Link to="/brand-marketing-strategy">Brand Marketing Strategy</Link></li>
                    <li><Link to="/social-media-marketing">Social Media Marketing</Link></li>
                    <li><Link to="/blog-development">Blog Development</Link></li>
                    <li><Link to="/email-marketing">Email Marketing</Link></li>
                    <li><Link to="/sms-marketing">SMS Marketing</Link></li>
                    <li><Link to="/lead-generation">Lead Generation</Link></li>
                  </ul>
                </li>

                <li className="nl-simple" aria-haspopup="true">
                  <Link to="/search-engine-optimization" className="h-link">SEO</Link>
                </li>

                <li aria-haspopup="true">
                  <span className="wsmenu-click"><i className="wsmenu-arrow"></i></span>
                  <a href="#" className="h-link">
                    Branding<span className="wsarrow"></span>
                  </a>
                  <ul className="sub-menu ico-10">
                    <li><Link to="/profile-designing">Profile Designing</Link></li>
                    <li><Link to="/brochure-designing">Brochure Design</Link></li>
                    <li><Link to="/e-brochure">E-Brochure</Link></li>
                    <li><Link to="/business-card-design">Business Card</Link></li>
                    <li><Link to="/corporate-identity">Corporate Identity</Link></li>
                    <li><Link to="/logo-design">Logo Design</Link></li>
                  </ul>
                </li>

                <li aria-haspopup="true">
                  <span className="wsmenu-click"><i className="wsmenu-arrow"></i></span>
                  <a href="#" className="h-link">
                    More services <span className="wsarrow"></span>
                  </a>
                  <ul className="sub-menu ico-10">
                    <li><Link to="/banner-ads-management">Banner Ads Management</Link></li>
                    <li><Link to="/personalized-product-catalogs">Customized Product Catalogs</Link></li>
                    <li><Link to="/information-architecture-strategy-planning">Information Architecture</Link></li>
                    <li><Link to="/pay-per-click-campaign-advertising">Pay Per Click Campaign Advertising</Link></li>
                    <li><Link to="/user-interface-design-service">User Interface Design Service</Link></li>
                  </ul>
                </li>

                {/* SIGN UP BUTTON */}
                <li className="nl-simple mobile-last-link" aria-haspopup="true">
                  <Link to="/contact-us" className="btn r-08 btn--tra-white hover--plum last-link">
                    let&rsquo;s Talk
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
